const WysiwygWithNumbers = {};

export default WysiwygWithNumbers